// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Production40FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Production40Filled: FC<Production40FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path
                d="M15.277 35.936c.052.417.412.73.84.73h7.767a.842.842 0 0 0 .84-.73l.53-4.197a.833.833 0 0 1 .409-.614l.533-.31.016-.01.707-.394a.86.86 0 0 1 .75-.042l3.892 1.633a.853.853 0 0 0 1.065-.35l3.886-6.642a.825.825 0 0 0-.221-1.079l-3.41-2.556a.829.829 0 0 1-.334-.663v-.305c0-.154 0-.455.026-1.141a.825.825 0 0 1 .332-.628l3.428-2.57a.825.825 0 0 0 .22-1.078l-3.886-6.643a.853.853 0 0 0-1.062-.352l-3.95 1.642a.845.845 0 0 1-.726-.035 17.372 17.372 0 0 1-.718-.407c-.164-.101-.367-.22-.54-.32a.844.844 0 0 1-.418-.623l-.53-4.188a.842.842 0 0 0-.84-.73h-7.767a.842.842 0 0 0-.84.73l-.53 4.2a.835.835 0 0 1-.405.612l-.347.207c-.07.043-.07.043-.278.163-.228.13-.416.233-.641.354a.858.858 0 0 1-.734.035l-3.946-1.64a.853.853 0 0 0-1.062.352L3.446 14.99a.825.825 0 0 0 .221 1.079l3.41 2.556a.83.83 0 0 1 .334.663v1.424c0 .26-.123.505-.333.663l-3.41 2.556a.825.825 0 0 0-.222 1.08l3.887 6.642a.853.853 0 0 0 1.062.352l3.929-1.634a.858.858 0 0 1 .76.05l.574.334.013.008.653.363c.233.13.39.361.424.623l.529 4.187ZM20 25.416a5.417 5.417 0 1 0 0-10.833 5.417 5.417 0 0 0 0 10.834Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Production40Filled;
